import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchApi } from '../utils/api';

function CategoryList() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await fetchApi('/categories');
        setCategories(data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    loadCategories();
  }, []);

  const handleCategoryClick = (categoryId) => {
    navigate(`/category/${categoryId}`);
  };

  return (
    <div>
      <h1 className="title">Categories</h1>
      {loading && <p className="subtitle">Loading categories...</p>}
      {error && <p className="subtitle has-text-danger">Error: {error}</p>}
      {!loading && !error && (
        <div className="columns is-multiline">
          {categories.map(category => (
            <div key={category.id} className="column is-one-third">
              <div className="card thought-bubble" onClick={() => handleCategoryClick(category.id)}>
                <div className="card-content">
                  <p className="title is-4">{category.name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CategoryList; 